export * from './slimscroll-options.class';
export * from './slimscroll.directive';
